import { render } from "./SupervisorClaims.vue?vue&type=template&id=d3db3622&scoped=true"
import script from "./SupervisorClaims.vue?vue&type=script&lang=js"
export * from "./SupervisorClaims.vue?vue&type=script&lang=js"

import "./SupervisorClaims.vue?vue&type=style&index=0&id=d3db3622&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3db3622"]])

export default __exports__